const styles = theme => ({
  orderListWrapper: {
    minHeight: '200px',
    overflow: 'auto',
  },
})
export default styles
